import { ChangeDetectionStrategy, Component, inject, type OnInit } from '@angular/core';
import { GridModule } from '@progress/kendo-angular-grid';
import { AsyncPipe } from '@angular/common';
import { OrganizationGridService } from './services/organization-grid.service';

@Component({
  selector: 'app-paging',
  standalone: true,
  imports: [
    GridModule,
    AsyncPipe
  ],
  templateUrl: './paging.component.html',
  styleUrl: './paging.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PagingComponent implements OnInit {

  public gridService = inject(OrganizationGridService);

  ngOnInit(): void {
    // Initial data load is handled in the service constructor
  }
}


